;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.FacebookConnect = Backbone.Model.extend({
		url: 'social_connections/facebook_connect',
		defaults: {
			token: '',
			user: {},
			email_permission: false
		},

		initialize: function(){
			this.on('facebook:login', function(auth_response){
				this.attributes.token = auth_response.accessToken;
				this.getUserPermissions();
			});

			this.on('facebook:me:save', this.saveFacebookUser);
		},

		initFacebookConnect: function(){
			this.faceBookLogin();
			return this;
		},

		getFacebookUserScopes: function() {
			return 'email';
		},

		faceBookLogin: function(){
			var _this = this,
				error = false,
				resp = false,
				login_context = {scope: this.getFacebookUserScopes(), return_scopes: true};

			if(!this.get('email_permission')){
				login_context.auth_type = 'rerequest';
			}

			FB.login(function(response) {

				if (response.authResponse) {

					resp =  response.authResponse;
				}
				else{
					resp = {error: true, text: 'Facebook login error'};
				}

				if(resp.error){
					_this.trigger('facebook:error', resp);
				}
				else {
					_this.trigger('facebook:login', resp);
				}


			}, login_context);

			return this;
		},

		getUserPermissions: function(){
			FB.api('/me/permissions',  this.checkFacebookLoginPermissions.bind(this));
			return this
		},

		getUserInfo: function(){
			var _this = this,
				fields = [
					'first_name',
					'last_name',
					'email',
					// 'gender',
					// 'birthday'
				].join(',');

			FB.api('/me',  { fields: fields }, function(response) {
				if(response){
					_this.trigger('facebook:me:save', response);
				}
				else{
					_this.trigger('facebook:error', {error: true, text: 'Something went wrong! Please try again.'});
				}
			});

			return this;
		},

		getLoginStatus: function(){

			var _this = this;

			FB.getLoginStatus(function(response) {

				if (response.status === 'connected') {
					_this.attributes.token = response.authResponse.accessToken;
					_this.trigger('facebook:status:connected');
				}

			});

			return this;
		},

		checkFacebookLoginPermissions: function(permissions){

			_.map(permissions.data, _.bind(function (perm) {
				if(perm.permission === 'email' && perm.status === 'granted'){
					this.attributes.email_permission = true;
					return;
				}
			}, this));

			if(!this.attributes.email_permission){
				this.trigger('facebook:error', {error: true, text: 'In order to use Facebook login on for this site you need to provide access to use your email address. Please try again and allow email access to email address.'});
			}
			else {
				this.getUserInfo();
			}
		},

		saveFacebookUser: function(facebook_user){
			let user = {},
				gender = facebook_user.gender,
				birthday = facebook_user.birthday;

			user.firstname  = facebook_user.first_name;
			user.lastname   = facebook_user.last_name;
			user.email      = facebook_user.email;
			user.conf_email = facebook_user.email;

			if(gender){
				user.gender = gender;
			}
			if(birthday){
				user.birthday = birthday;
			}

			this.attributes.user = user;
			this.trigger('facebook:connect:success');
		},
	});

}(window, APP, Backbone, Marionette, $, _));
